<!--
  ~ Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

@if (label) {
  <p-floatLabel [variant]="floatLabelVariant">
    <bs-autocomplete
      bsFloatLabelCompat
      inputId="countyDropdown"
      [ngModel]="selectedCountyName"
      (ngModelChange)="selectedCountyName = $event"
      [items]="result() ?? []"
      [dropdown]="true"
      [requireSelection]="true"
      [disabled]="disabled"
      [minLength]="0"
      (queryChange)="onQueryChange($event)"
      (selected)="onSelect()"
      (cleared)="onClear()"
      (blurred)="onBlur()" data-testid="selected-county-name-autocomplete">
    </bs-autocomplete>
    <label for="countyDropdown">{{ label }}</label>
  </p-floatLabel>
} @else {
  <bs-autocomplete
    inputId="countyDropdown"
    [ngModel]="selectedCountyName"
    (ngModelChange)="selectedCountyName = $event"
    [items]="result() ?? []"
    [dropdown]="true"
    [requireSelection]="true"
    [disabled]="disabled"
    [minLength]="0"
    (queryChange)="onQueryChange($event)"
    (selected)="onSelect()"
    (cleared)="onClear()"
    (blurred)="onBlur()" data-testid="selected-county-name-autocomplete-2">
  </bs-autocomplete>
}


